<template>
  <TabBtn
    :tabs="tabs"
    :active-tab="currentTab.value"
    height="100%"
    @tab-click="tabClick"
    class="cost-pricing"
  >
    <template slot="btn">
      <FormItems :form="form" />
    </template>
    <template>
      <div class="box">
        <div class="btn-box">
          <el-button
            v-if="currentTab.value === 'CostPricingQtfy'"
            type="primary"
            size="mini"
            @click="handleQufeijisuan"
            style="margin-bottom: 10px"
            >取费计算</el-button
          >
        </div>

        <Banzufenbao
          ref="banzufenbao"
          v-if="currentTab.value === 'CostPricingBzfb'"
          v-bind="$attrs"
          :summaryData="summaryData"
          :getSummaryData="getSummaryData"
          :importRecordId="importRecordId"
        />
        <SimpleTable
          v-else
          :showIndex="false"
          :table-code="currentTab.value"
          :ref="currentTab.value"
          :bottomFrozenRowCount="1"
          :loading="loading"
          :columns="currentTab.columns"
          :data="tableData"
          :menus="['查询', '批量修改', '批量删除', '插入']"
          :menusMergeAfter="menusMerge"
          @modify-data-change="onModifyData"
        />
      </div>
    </template>
    <SelectBaseAmountDialog
      ref="SelectBaseAmountDialog"
      @confirm="handleSelectBaseAmountDialogConfirm"
    />
  </TabBtn>
</template>

<script>
import TabBtn from '@/components/TabBtn/index.vue'
import Banzufenbao from './Banzufenbao.vue'
import SimpleTable from '@/components/SimpleTable/index.vue'
import {
  sortRecords,
  aggregationAmount,
  aggregationSUM,
  addCbFn,
  initCalculation
} from '@/utils/index'
import FormItems from '@/components/FormItems/index.vue'
import SelectBaseAmountDialog from './SelectBaseAmountDialog.vue'

export default {
  name: 'CostPricing',
  components: {
    TabBtn,
    Banzufenbao,
    SimpleTable,
    FormItems,
    SelectBaseAmountDialog
  },
  inject: ['detailsVm'],
  props: {
    importRecordId: {
      type: String,
      default: ''
    },
    basicInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      // 页面数据
      tabs: [
        {
          label: '班组分包',
          value: 'CostPricingBzfb'
        },
        {
          label: '甲供材料',
          value: 'CostPricingJgcl',
          type: '1',
          columns: [
            { field: 'code', title: '编码', aggregation: aggregationSUM },
            { field: 'name', title: '材料名称' },
            { field: 'spec', title: '规格型号' },
            { field: 'unit', title: '单位' },
            { field: 'quantity', title: '数量' },
            {
              field: 'rate',
              title: '单价',
              fieldType: 'number',
              canEdit: true,
              canModify: true
            },
            {
              field: 'amount',
              title: '金额',
              calculation: initCalculation(
                ['rate', 'quantity'],
                'rate * quantity'
              ),
              aggregation: aggregationAmount
            }
          ]
        },
        {
          label: '总包材料',
          value: 'CostPricingZbcl',
          type: '2',
          columns: [
            { field: 'code', title: '编码', aggregation: aggregationSUM },
            { field: 'name', title: '材料名称' },
            { field: 'spec', title: '规格型号' },
            { field: 'unit', title: '单位' },
            { field: 'quantity', title: '数量' },
            {
              field: 'rate',
              title: '单价',
              fieldType: 'number',
              canEdit: true,
              canModify: true
            },
            {
              field: 'amount',
              title: '金额',
              calculation: initCalculation(
                ['rate', 'quantity'],
                'rate * quantity'
              ),
              aggregation: aggregationAmount
            }
          ]
        },
        {
          label: '总包机械',
          value: 'CostPricingZbjx',
          type: '3',
          columns: [
            { field: 'code', title: '编码', aggregation: aggregationSUM },
            { field: 'name', title: '材料名称' },
            { field: 'spec', title: '规格型号' },
            { field: 'unit', title: '单位' },
            { field: 'quantity', title: '数量' },
            {
              field: 'rate',
              title: '单价',
              fieldType: 'number',
              canEdit: true,
              canModify: true
            },
            {
              field: 'amount',
              title: '金额',
              calculation: initCalculation(
                ['rate', 'quantity'],
                'rate * quantity'
              ),
              aggregation: aggregationAmount
            }
          ]
        },
        {
          label: '其他费用',
          value: 'CostPricingQtfy',
          columns: [
            {
              field: 'code',
              title: '编码',
              canEdit: true,
              canModify: true,
              aggregation: aggregationSUM
            },
            {
              field: 'name',
              title: '费用名称',
              canEdit: true,
              canModify: true
            },
            {
              field: 'baseAmount',
              title: '取费基数',
              canModify: true
            },
            {
              field: 'costRatio',
              title: '费率',
              fieldType: 'number',
              canEdit: true,
              canModify: true
            },
            {
              field: 'amount',
              title: '金额',
              fieldType: 'number',
              canEdit: true,
              canModify: true,
              aggregation: aggregationAmount
            }
          ]
        }
      ],
      currentTab: {},
      tableData: [],
      summaryData: {},
      loading: false
    }
  },
  computed: {
    form() {
      return [
        {
          label: '成本计价',
          value: this.summaryData.costPricingAmount,
          disabled: true
        }
      ]
    }
  },
  watch: {
    importRecordId() {
      this.getTableData()
      this.getSummaryData()
    }
  },
  created() {
    this.init()
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    init() {
      this.tabClick(this.tabs[0])
      this.getSummaryData()
    },

    initTableData() {
      if (this.currentTab.value === 'CostPricingBzfb') {
        this.$refs.banzufenbao.getTableDataLeft()
      } else {
        this.getTableData()
      }
    },

    async getSummaryData() {
      const res = await this.$service.get(
        '/project-unit-budget/import-record/cost-pricing-aggregation/' +
          this.importRecordId,
        {
          importRecordId: this.importRecordId
        }
      )
      if (res.code === 200) {
        this.summaryData = res.data || {}
      }
    },

    tabClick(tab) {
      this.currentTab = tab
      this.getTableData()
    },

    async getTableData() {
      if (this.currentTab.value === 'CostPricingBzfb') return
      const url =
        this.currentTab.value === 'CostPricingQtfy'
          ? '/project-unit-budget/cb-other/list'
          : '/project-unit-budget/cb-resource/list'
      this.tableData = []
      this.loading = true
      const res = await this.$service.get(url, {
        importRecordId: this.importRecordId,
        type: this.currentTab.type
      })
      this.tableData = sortRecords(res.data || [])
      this.loading = false
    },

    async onModifyData(getModifyData, cleanModifyData) {
      const url =
        this.currentTab.value === 'CostPricingQtfy'
          ? '/project-unit-budget/cb-other/batch'
          : '/project-unit-budget/cb-resource/batch'
      await addCbFn(this.$service, url, getModifyData, cleanModifyData, arr =>
        arr.map(e => ({
          ...e,
          importRecordId: this.importRecordId,
          budgetId: this.basicInfo.id
        }))
      )
      this.getSummaryData()
    },

    menusMerge(contextMenuMap) {
      if (this.currentTab.value === 'CostPricingQtfy') {
        contextMenuMap['批量修改'] = () => this.handleEdit()
      }
    },

    handleEdit() {
      const field =
        this.$refs[this.currentTab.value].getSelectData()[0][0]?.field
      if (field === 'baseAmount') {
        this.handleEditBillBaseAmount()
      } else {
        this.$refs[this.currentTab.value].handleEdit()
      }
    },

    // 取费基数编辑
    handleEditBillBaseAmount() {
      const selectedCellInfos =
        this.$refs[this.currentTab.value].getSelectData()
      if (selectedCellInfos.length !== 1)
        return this.$message.warning('只能修改一条数据！')
      this.$refs.SelectBaseAmountDialog.show({
        inProp: 'name',
        tableDataOut: [
          { tabName: '班组分包', keyName: '班组分包', total: false },
          { tabName: '甲供材料', keyName: '金额', total: false },
          { tabName: '总包材料', keyName: '金额', total: false },
          { tabName: '总包机械', keyName: '金额', total: false }
        ],
        id: this.importRecordId,
        selectedCellInfos: selectedCellInfos,
        tableVm: this.$refs[this.currentTab.value]
      })
    },

    // 取费基数编辑确认
    handleSelectBaseAmountDialogConfirm(selectedCellInfos, str) {
      selectedCellInfos.forEach(cells => {
        const obj = cells[0].originData
        this.$set(obj, 'baseAmount', str)
        this.$refs[this.currentTab.value].modifyData.set(obj, obj)
      })
    },

    async handleFyhz() {},

    async handleQufeijisuan() {
      this.detailsVm.loadingContainer = true
      const res = await this.$service.post(
        '/project-unit-budget/cb-other/calculateAmount/' + this.importRecordId,
        { id: this.importRecordId }
      )
      this.detailsVm.loadingContainer = false
      this.getTableData()
    }
  }
}
</script>

<style scoped lang="less">
.cost-pricing {
  .box {
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
  }
}
</style>
